import { gql } from "@apollo/client";

export const GET_IT_APPLICATION_DASHBOARD = gql`
  query GetItApplicationsDashboard {
    getItApplicationsDashboard {
      cards {
        applicationsMapped {
          count
          isEnabled
        }
        businessFunctionsMapped {
          count
          isEnabled
        }
        qualitativeFactorsMapped {
          count
          isEnabled
        }
      }
      applications {
        businessFunctions
        name
        tier {
          name
          color
        }
        qualitativeFactors {
          compliance
          count
          employees
          lifeSafety
          reputation
        }
        revenue
        uuid
      }
    }
  }
`;
